<template>
	<slot>
	</slot>
</template>

<script>
	require('intersection-observer');

	export default {
		name: 'hidden-element',
		props: {
			threshold: {
				type: Array,
				default: [0.5]
			}
		},
		render() {
			try {
				return this.$slots.default[0];
			} catch (e) {
				throw new Error('hiddenElement.vue can only render one, and exactly one child component.');
			}

			return null;
		},
		mounted () {
			this.$slots.default[0].elm.classList.add('h-hidden-element');

			var timeline = document.querySelector('.o-timeline')

			if (timeline) {
				this.observer = new IntersectionObserver((entries) => {
					if (entries[0].isIntersecting || entries[0].intersectionRatio > 0.5) {
						entries[0].target.classList.add('is-visible');
					}
				},{
					root : timeline, //returns timeline if it exists, else null (which is root). Not the best but hey
					threshold: 0.5
				});
			}
			else {
				this.observer = new IntersectionObserver((entries) => {
					if (entries[0].isIntersecting || entries[0].intersectionRatio > 0.5) {
						entries[0].target.classList.add('is-visible');
					}
				});
			}

			this.$nextTick(() => {
				this.observer.observe(this.$slots.default[0].elm);
			});
		},
		destroyed() {
    	this.observer.disconnect();
  	}
	};
</script>



// WEBPACK FOOTER //
// hidden-element.vue?013c26b6